<template>
  <v-container fluid>
    <h1 class="display-inline">Report: Workload review</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <WeeklyPlan :showStaffNavigator="true"/>
  </v-container>
</template>

<script>


import WeeklyPlan from "@/components/capacity/WeeklyPlan.vue"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "StaffPlanScheduleReviewPage",
  permissions: [...WeeklyPlan.permissions],
  components: {ActiveApiCalls, WeeklyPlan},
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>